import { z } from 'zod';
import { vehicleKinds } from './organizations';

export const EvidenceUrl = z
  .string()
  .url()
  .max(500)
  .regex(/^https?:\/\//);
export const CatalogReviewSchema = z.object({
  checkedAt: z.string().max(40),
  federalState: z.string().max(60),
  municipality: z.string().max(100),
  municipalityCode: z.string().max(12),
  originalName: z.string().max(160),
  nameMethod: z.enum(['osm', 'operator', 'locality', 'published', 'unresolved']),
  nameSourceUrl: EvidenceUrl,
  boundarySourceUrl: EvidenceUrl,
  directorySourceUrl: EvidenceUrl.optional(),
  operational: z.enum(['listed', 'inactive', 'uncertain']),
  fleetStatus: z.enum(['unverified', 'published']),
});
export const PublishedVehicleSchema = z.object({
  id: z.string().min(1).max(100),
  typeLabel: z.string().min(1).max(100),
  kind: z.enum(vehicleKinds).optional(),
  callSign: z.string().min(2).max(100).optional(),
  radioIdentifier: z.string().min(1).max(30).optional(),
  unitOnly: z.boolean().optional(),
  dutyWindows: z.array(z.object({
    days: z.array(z.number().int().min(1).max(7)).min(1).max(7),
    startMinute: z.number().int().min(0).max(1439),
    endMinute: z.number().int().min(1).max(1440),
  }).refine(w => w.endMinute > w.startMinute)).max(14).optional(),
  sourceUrl: EvidenceUrl,
  checkedAt: z.string().max(40),
  availability: z.enum(['published', 'planned', 'historical', 'unconfirmed']).default('published'),
  note: z.string().max(500).optional(),
});
export const PublishedFleetSchema = z.object({
  sourceTitle: z.string().max(160),
  sourceUrl: EvidenceUrl,
  checkedAt: z.string().max(40),
  coverage: z.enum(['published-list', 'partial']),
  vehicles: z.array(PublishedVehicleSchema).max(200),
  note: z.string().max(1000).optional(),
});
export type PublishedVehicle = z.infer<typeof PublishedVehicleSchema>;
export type PublishedFleet = z.infer<typeof PublishedFleetSchema>;
export type CatalogReview = z.infer<typeof CatalogReviewSchema>;
